export enum WEBSTORE_QUERIES_ENUM {
  WEB_MERCHANT = 'WEB_MERCHANT',
  WEBSTORES = 'WEBSTORES',
  WEBSTORES_REDIRECT_MERCHANT = 'WEBSTORES_REDIRECT_MERCHANT',
  WEBSTORES_REDIRECT_UUID = 'WEBSTORES_REDIRECT_UUID',
  PLACEPICKER_TEMPLATE = 'PLACEPICKER_TEMPLATE',
  PLACEPICKER_LEGACY_STORE_LIST = 'PLACEPICKER_LEGACY_STORE_LIST',
}
